import { render, staticRenderFns } from "./aidaHome.vue?vue&type=template&id=608756c0&scoped=true&"
import script from "./aidaHome.vue?vue&type=script&lang=js&"
export * from "./aidaHome.vue?vue&type=script&lang=js&"
import style0 from "./aidaHome.vue?vue&type=style&index=0&id=608756c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608756c0",
  null
  
)

export default component.exports